import { ALLOCATION_PRICING_METHOD, CARGO_TYPE_ID } from '@types';

export const getPricingMethodFromCargoType = (cargoTypeId: number): ALLOCATION_PRICING_METHOD | null => {
	switch (cargoTypeId) {
	case CARGO_TYPE_ID.Pallets: return ALLOCATION_PRICING_METHOD.PALLETS;
	case CARGO_TYPE_ID.FullTruckload: return ALLOCATION_PRICING_METHOD.FULL_LOAD;
	case CARGO_TYPE_ID.Loose: return ALLOCATION_PRICING_METHOD.LOOSE;
	case CARGO_TYPE_ID.Other: return ALLOCATION_PRICING_METHOD.CPK;
	// Bundle and Skid are priced the same way as Other (see OTHER_FAMILY_CARGO_TYPES in @types).
	case CARGO_TYPE_ID.Bundle: return ALLOCATION_PRICING_METHOD.CPK;
	case CARGO_TYPE_ID.Skid: return ALLOCATION_PRICING_METHOD.CPK;
	case CARGO_TYPE_ID.CustomItem: return ALLOCATION_PRICING_METHOD.CUSTOM_ITEM;
	default: return null;
	}
};
